module.exports = __webpack_public_path__ + "static/media/015-Aktivierung_ID_22.f2d9499a.mp3";